
export const enum CursorMode {
  Draw,
  Select
}
